
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import addLeadingZeros from '@util/addLeadingZeros';

  @Component({
    name: 'DateField',
  })
export default class DateField extends Vue {
    @Prop() date: Date;

    getDateDescription(day) {
      switch (day) {
        case (0):
          return 'Sonntag';
        case (1):
          return 'Montag';
        case (2):
          return 'Dienstag';
        case (3):
          return 'Mittwoch';
        case (4):
          return 'Donnerstag';
        case (5):
          return 'Freitag';
        case (6):
          return 'Samstag';
      }
    }
}
